import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FuseWidgetModule} from '../../../../@fuse/components';
import {FuseSharedModule} from '../../../../@fuse/shared.module';
import {KluhSharedModule} from '../../kluh-shared.module';
import {TextFileDaoService} from './text-file-dao-service';


@NgModule({
    imports: [
        CommonModule,
        FuseSharedModule,
        FuseWidgetModule,
        KluhSharedModule,
    ],
    declarations: [],
    providers: [TextFileDaoService]
})
export class TextFileModule {
}
